import {$, HttpBody, ID, Resource, TAG} from 'simpli-web-sdk'
import TipoFotoAtlasSchema from '@/schema/TipoFotoAtlas.schema.ts'

export default class TipoFotoAtlas extends Resource {

  static readonly EPIS_FERRAMENTA = 1
  static readonly LACRES = 2
  static readonly ESPELHOS = 3
  static readonly GUIAS = 4
  static readonly PEDRAS_CONTRAPESO = 5
  static readonly VOLUMES_ARMAZENADOS = 6

  static async getListTipoFotoAtlas(spinner = 'getListTipoFotoAtlas') {
    const fetch = () => new HttpBody<TipoFotoAtlas[]>().GET(`/user/carga/tipo-foto-atlas`)
    return await $.await.run(fetch, spinner)
  }

  readonly $name: string = 'TipoFotoAtlas'

  readonly $endpoint: string = '/user/tipo-foto-atlas'

  get $schema() {
    return TipoFotoAtlasSchema(this)
  }

  get $id() {
    return this.idTipoFotoAtlasPk
  }
  set $id(val: ID) {
    this.idTipoFotoAtlasPk = val
  }
  get $tag() {
    return this.descricao
  }
  set $tag(val: TAG) {
    this.descricao = val
  }

  idTipoFotoAtlasPk: ID = 0
  descricao: string = ''
  obrigatorio: boolean = false
}
